<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">
            Última Sincronização
            {{ tarefa ? tarefa.tarefa : '' }}
          </label>
        </div>
      </div>
    </div>
    <EmptyState
      v-if="nuncaSincronizada"
      icon="sync"
      title="Nunca sincronizada"
      description="Esta carga ainda não foi sincronizada. Execute uma sincronização para ver os detalhes aqui."
    />

    <div v-else class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-hover" style="margin-left: auto; margin-right: auto;">
            <thead>
            <tr>
              <th>Campo</th>
              <th>Valor</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(valor, chave) in ultimaSincronizacao" :key="chave">
              <td>{{ rotulo(chave) }}</td>
              <td>
                <MensagemRetorno v-if="ehCampoMensagem(chave)" :mensagem="valor" :sucesso="sucessoUltima" larga />
                <span
                  v-else-if="ehCampoSucesso(chave)"
                  class="label"
                  :class="valor ? 'success' : 'error'"
                >
                  {{ valor ? 'Sim' : 'Não' }}
                </span>
                <div v-else class="valor-sincronizacao">{{ formatarValor(chave, valor) }}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MensagemRetorno from "./MensagemRetorno";
import EmptyState from "@/components/EmptyState";
import { toDateTime } from "@/helpers/utils";

const ROTULOS = {
  id: "ID",
  sucesso: "Sucesso",
  msg: "Mensagem",
  mensagem_retorno: "Mensagem",
  tempo_execucao: "Tempo de execução",
  dthora_inicio: "Início",
  dthora_fim: "Fim",
  dthora: "Data/Hora",
  modo: "Modo",
  tarefa: "Tarefa",
  registros: "Registros",
  registros_afetados: "Registros afetados",
  total_registros: "Total de registros",
};

export default {
  name: "UltimaCarga",
  props:[
    "tarefa"
  ],
  components: {
    MensagemRetorno,
    EmptyState,
  },
  methods: {
    ehCampoMensagem(chave) {
      return ["msg", "mensagem_retorno"].includes(chave);
    },
    ehCampoSucesso(chave) {
      return chave === "sucesso";
    },
    ehCampoData(chave) {
      return /^dthora/.test(chave) || /data/i.test(chave);
    },
    rotulo(chave) {
      return ROTULOS[chave] || chave;
    },
    formatarValor(chave, valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "—";
      }
      if (this.ehCampoData(chave)) {
        const data = new Date(valor);
        return isNaN(data.getTime()) ? valor : toDateTime(valor);
      }
      if (chave === "tempo_execucao") {
        return `${valor} seg`;
      }
      return valor;
    },
  },
  computed: {
    nuncaSincronizada() {
      const real = this.tarefa && this.tarefa.ultimaSincronizacao;
      return !real || Object.keys(real).length === 0;
    },
    ultimaSincronizacao() {
      return (this.tarefa && this.tarefa.ultimaSincronizacao) || {};
    },
    // Sucesso da última sincronização, repassado ao MensagemRetorno para garantir
    // o botão "Copiar" em toda falha (inclusive mensagens curtas/não interpretadas).
    sucessoUltima() {
      return !!this.ultimaSincronizacao.sucesso;
    },
  },
}
</script>

<style scoped>
.valor-sincronizacao {
  display: block;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>